import { render, staticRenderFns } from "./appReleases.vue?vue&type=template&id=1816345e&scoped=true&"
import script from "./appReleases.vue?vue&type=script&lang=js&"
export * from "./appReleases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1816345e",
  null
  
)

export default component.exports